// extracted by mini-css-extract-plugin
export default {"selectedPage":"Paginator_selectedPage__XmOdJ"};